import { useAllWorkspaces, useCurrentWorkspace } from "../api/helpers";

export function useWorkspacePageLoading() {
    const { isLoading: isCurrentWorkspaceLoading } = useCurrentWorkspace();
    const { isLoading: isWorkspacesListLoading } = useAllWorkspaces();

    return isWorkspacesListLoading || isCurrentWorkspaceLoading;
}
